/**
 * Copyright 2014, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
module.exports = require('./lib/Dispatcher');



/*****************
 ** WEBPACK FOOTER
 ** ./~/dispatchr/index.js
 ** module id = 948
 ** module chunks = 0
 **/